import { Box, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  width: "95px",
  display:"flex",
  justifyContent:"center",
  background: theme.palette.custom.primary,
  fontSize: theme.typography.extraLarge.fontSize,
  borderRadius: theme.borderRadius.radius.extraLarge,
  padding: "3px 17px",
  alignItems: "center",
  [theme.breakpoints.down("xs")]: {
    padding: "3px 10px",
  },
}));
export const StyledTypographyWork = styled("span")(({ theme }) => ({
  color: theme.palette.custom.white,
  background: theme.palette.custom.successStepper,
  fontSize: theme.typography.extraLarge.fontSize,
  borderRadius: theme.borderRadius.radius.extraLarge,
  padding: "3px 17px",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("xs")]: {
    padding: "3px 10px",
  },
}));

export const StyledTypographyDefault = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.primary,
  background: theme.palette.custom.white,
  fontSize: theme.typography.extraLarge.fontSize,
  borderRadius: "50%",
  border: "1px solid #0B65B5",
  width: "36px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  cursor: "pointer",
}));
export const StyledBoxDefault = styled(Box)(({ theme, isdefault }) => ({
  padding: "28px",
  background: isdefault === "true" ? theme.palette.custom.white : "#F0F7FE",
  margin: "40px 26px",
  [theme.breakpoints.down("xs")]: {
    padding: "10px",
  },

  border: !isdefault ? "1px solid #EAEAEA" : "1px solid #0B65B5",
  borderRadius: theme.borderRadius.radius.large,
}));
export const StyledBoxDefaultInfo = styled(Box)(({ theme, isdefault }) => ({
  padding: "28px",
  background: !isdefault ? theme.palette.custom.white : "#F0F7FE",
  border: !isdefault ? "1px solid #EAEAEA" : "1px solid #0B65B5",
  borderRadius: theme.borderRadius.radius.large,
  height: "100%",
}));

export const StyledTypographyHomeInform = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  background: theme.palette.custom.primary,
  fontSize: theme.typography.base.fontSize,
  borderRadius: theme.borderRadius.radius.extraLarge,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "3.5px 14px",
  display: "flex",
  alignItems: "center",
}));

export const StyledTypographyDefaultInform = styled("span")(({ theme }) => ({
  color: theme.palette.custom.primary,
  background: theme.palette.custom.white,
  fontSize: theme.typography.base.fontSize,
  borderRadius: theme.borderRadius.radius.extraLarge,
  fontWeight: theme.typography.fontWeight.medium,
  border: "1px solid #0B65B5",
  padding: "3px 14px",
  display: "flex",
  alignItems: "center",
}));

export const StyledTypographyWorkInform = styled("span")(({ theme }) => ({
  color: theme.palette.custom.white,
  background: theme.palette.custom.orderButtonColor,
  fontSize: theme.typography.base.fontSize,
  borderRadius: theme.borderRadius.radius.extraLarge,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "3px 14px",
  display: "flex",
  alignItems: "center",
}));

export const StyledAddressHeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "12px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
export const StyledTypeContentBox = styled(Box)(() => ({
  display: "flex",
  gap: "11px",
  alignItems: "center",
  flexWrap: "wrap",
}));
export const StyledHomeDefaultLabelBox = styled(Box)(() => ({
  display: "flex",
  gap: "11px",
  alignItems: "center",
  flexWrap: "wrap",
}));
export const StyledAddressActionsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    gap: "8px",
  },
}));
export const StyledAddressFormBox = styled(Box)(() => ({
  paddingTop: "45px",
}));

/**
 * Profile page address cards only — uniform labels & inputs.
 * Children must set data-profile-address-field on each field root (via profileForm prop).
 */
export const StyledProfileAddressFields = styled(Box)(({ theme }) => ({
  width: "100%",
  "& [data-profile-address-field]": {
    paddingTop: "0 !important",
    width: "100%",
  },
  "& [data-profile-address-field] > div:first-of-type": {
    fontSize: theme.typography.small.fontSize,
    fontWeight: theme.typography.fontWeight.medium,
    lineHeight: 1.4,
    marginBottom: "6px",
    minHeight: "unset",
    color: theme.palette.custom.productTextColor,
  },
  "& [data-profile-address-field] .MuiOutlinedInput-root": {
    height: "44px !important",
    minHeight: "44px !important",
    maxHeight: "44px !important",
    boxSizing: "border-box",
    borderRadius: theme.borderRadius.radius.wallet,
    backgroundColor: `${theme.palette.custom.white} !important`,
    padding: "0 12px !important",
  },
  "& [data-profile-address-field] .MuiOutlinedInput-root.Mui-error": {
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
  "& [data-profile-address-field] .MuiInputBase-input": {
    fontSize: `${theme.typography.medium.fontSize} !important`,
    fontWeight: 400,
    lineHeight: "20px !important",
    height: "20px !important",
    minHeight: "20px !important",
    padding: "0 !important",
    color: theme.palette.custom.lightGrey,
  },
  "& [data-profile-address-field] .MuiAutocomplete-input": {
    fontSize: `${theme.typography.medium.fontSize} !important`,
    lineHeight: "20px !important",
    padding: "0 !important",
  },
  "& [data-profile-address-field] .MuiFormHelperText-root": {
    fontSize: theme.typography.micro.fontSize,
    marginTop: "4px",
    marginLeft: 0,
    lineHeight: 1.3,
    minHeight: "16px",
  },
  "& [data-profile-address-field] .MuiAutocomplete-endAdornment": {
    top: "50%",
    transform: "translateY(-50%)",
    right: "8px",
  },
}));
/** 50% width on lg/md when country is hidden — state + city + zip beside street */
export const ADDRESS_FIELD_HALF_GRID = { lg: 6, md: 6, sm: 12, xs: 12 };

export const StyledAddressFieldGrid = styled(Grid)(({ theme }) => ({
  minWidth: 0,
  "& > *": {
    width: "100%",
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    flexBasis: "100%",
    maxWidth: "100%",
  },
}));

/** Equal-width columns for country / state / city / zip on profile & address forms */
export const StyledLocationFieldsRow = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "$columns" && prop !== "$formGrid" && prop !== "$twoRowHalfGrid",
})(({ theme, $columns = 4, $formGrid, $twoRowHalfGrid }) => ({
  display: "grid",
  gridTemplateColumns: $twoRowHalfGrid
    ? "repeat(2, minmax(0, 1fr))"
    : $formGrid
      ? $columns === 3
        ? "repeat(3, minmax(0, 1fr))"
        : "repeat(2, minmax(0, 1fr))"
      : `repeat(${$columns}, minmax(0, 1fr))`,
  gap: $formGrid ? 8 : 16,
  width: "100%",
  alignItems: "start",
  ...($twoRowHalfGrid && {
    "& > *:nth-of-type(1)": { gridColumn: 1, gridRow: 1 },
    "& > *:nth-of-type(2)": { gridColumn: 1, gridRow: 2 },
    "& > *:nth-of-type(3)": { gridColumn: 2, gridRow: 2 },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
      "& > *:nth-of-type(1)": { gridColumn: "auto", gridRow: "auto" },
      "& > *:nth-of-type(2)": { gridColumn: "auto", gridRow: "auto" },
      "& > *:nth-of-type(3)": { gridColumn: "auto", gridRow: "auto" },
    },
  }),
  ...(!$formGrid &&
    !$twoRowHalfGrid && {
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns:
          $columns >= 4
            ? "repeat(2, minmax(0, 1fr))"
            : `repeat(${$columns}, minmax(0, 1fr))`,
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    }),
  ...($formGrid &&
    !$twoRowHalfGrid && {
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr",
      },
    }),
}));

StyledLocationFieldsRow.defaultProps = {
  "data-vl-location-row": "",
};

const locationFieldInputHeightLock = (theme) => ({
  "& .MuiAutocomplete-root": {
    background: "transparent !important",
  },
  "& .MuiOutlinedInput-root": {
    height: "48px !important",
    minHeight: "48px !important",
    maxHeight: "48px !important",
    boxSizing: "border-box",
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
  "& .MuiOutlinedInput-root.Mui-error": {
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    height: "48px !important",
    minHeight: "48px !important",
    maxHeight: "48px !important",
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.Mui-focused": {
    height: "48px !important",
    minHeight: "48px !important",
    maxHeight: "48px !important",
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.Mui-error": {
    backgroundColor: `${theme.palette.custom.white} !important`,
  },
});

export const StyledLocationFieldCell = styled(Box)(({ theme }) => ({
  minWidth: 0,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  background: "transparent",
  "& > *": {
    width: "100%",
    maxWidth: "100%",
    background: "transparent",
  },
  ...locationFieldInputHeightLock(theme),
}));
export const StyledOuterBox = styled(Box)(() => ({
  padding: "20px 26px",
  width: "100%",
}));
export const StyledInnerBox = styled(Box)(() => ({
  width: "auto",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));
export const StyledActionButtonWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "30px 26px",
  gap: "16px",
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    padding: "24px 20px",
  },
}));
export const StyledActionButtonsBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  flexWrap: "wrap",
}));
export const StyledLocationInfoBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  alignItems: "center",
  marginTop: "30px",
  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
  },
}));
export const StyledAddressBox = styled(Box)(({ theme }) => ({
  minWidth: 0,
  overflowWrap: "break-word",
  wordBreak: "normal",
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledButtonGroupWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "16px",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "24px",
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
  },
}));
export const StyledSetDefaultText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  cursor: "pointer",
  border: `1px solid ${theme.palette.custom.primary}`,
  color: theme.palette.custom.primary,
  borderRadius: "8px",
  padding: "6px 14px",
  fontWeight: theme.typography.fontWeight.medium,
  whiteSpace: "nowrap",
  userSelect: "none",
  "&:hover": {
    background: theme.palette.custom.primary,
    color: theme.palette.custom.white,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
    padding: "4px 10px",
  },
}));
export const StyledImg = styled("img")(() => ({
  cursor: "pointer",
}));
export const StyledError = styled(Box)(({ theme }) => ({
  color: theme.palette.custom.danger,
  marginBottom: "10px",
}));
